import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const SWECSportsFestPratiyogita2026 = () => {
    const festImages = [
        "IMG-20260228-WA0008.jpg",
        "IMG-20260228-WA0052.jpg",
        "IMG-20260228-WA0074.jpg",
        "IMG-20260228-WA0080.jpg",
        "IMG-20260228-WA0081.jpg",
        "IMG-20260228-WA0082.jpg",
    ];

    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2>
                                        SWEC Sports Fest “Pratiyogita” – February 27 & 28, 2026
                                    </h2>

                                    <div className='py-2'>
                                        <p>
                                            SWEC Sports Fest <strong>“Pratiyogita”</strong> was successfully conducted on February 27th and 28th, 2026. The inaugural ceremony was graced by the Chief Guest, <strong>Smt. Chepur Sridevi</strong>, who emphasized the importance of sports in promoting discipline, sportsmanship, and stress relief among students.
                                        </p>

                                        <p>
                                            The fest featured various competitive games including Basketball, Throwball, Kho-Kho, Volleyball, Kabaddi, Chess, and Shotput. Teams from several prestigious colleges such as VJIT, VBIT, CBIT, VNR VJIET, Vasavi College of Engineering, and HITAM actively participated, making the event highly competitive and vibrant.
                                        </p>

                                        <p>
                                            During the valedictory ceremony, winners were felicitated for their outstanding performances. <strong>SWEC won Kho-Kho</strong>, while <strong>VNR VJIET secured victories in Basketball, Kabaddi, and Volleyball</strong>. <strong>HITAM won Throwball</strong>, and the winners of <strong>Chess and Shotput were from SWEC</strong>.
                                        </p>

                                        <p>
                                            The event was successfully organized under the guidance of the Management and Principal <strong>Dr. A. Narmada</strong>, with the support of Faculty Coordinators <strong>Dr. P. Rajalingam</strong> and <strong>Mr. B. Sudhakar Reddy</strong>, along with Student Coordinators <strong>Ms. Meghana</strong> and <strong>Ms. Charishma</strong>. Faculty members and student volunteers played a key role in ensuring the grand success of the fest. Principal Dr. A. Narmada expressed gratitude to the Management for their continuous support in organizing such fests, fostering a vibrant campus life.
                                        </p>
                                    </div>

                                    <div className="css-script-ads"></div>
                                    <div className="spotlight-group">
                                        <div className="row">
                                            {festImages.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/SWEC-Sports-Fest-Pratiyogita-2026/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/SWEC-Sports-Fest-Pratiyogita-2026/${img}`}
                                                            alt={`SWEC Sports Fest Pratiyogita 2026 Image ${index + 1}`}
                                                            className="img-responsive center-block"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default SWECSportsFestPratiyogita2026;